// HTML statico e stili del modale builder. Nessuno stato: il wiring
// (builderModal.js) mostra/nasconde e attiva gli elementi.

import {
  BUILDER_ESSENCES,
  GRADIENT_INTENSITIES,
  BUILDER_TECHNIQUES,
  BUILDER_INTENSITIES,
  ATMOSPHERES,
  BUILDER_PALETTES,
  BUILDER_ELEMENT_CATEGORIES,
  FRAME_STYLES,
  FRAME_RICHNESS,
  FRAME_COVERAGES,
  FRAME_RELATIONS,
  FRAME_MARGIN_LEVELS,
  MAX_ELEMENTS,
  CUSTOM_TEXT_MAX_LENGTH,
  scenesForOrientation,
  SACRED_FIGURES,
  SACRED_FRAMINGS,
  SACRED_PERSPECTIVES,
  SACRED_MOODS,
  BUILDER_PAPERS,
  PAPER_GRAINS,
  BUILDER_MATERIALS,
  MATERIAL_INTENSITIES,
} from './builderCatalog';
import { elementIconSvg } from './builderIcons';

export const MODAL_ID = 'aiBackgroundBuilderModal';
export const TABS = ['base', 'elements', 'style', 'frame'];
export const TAB_TITLES = {
  base: 'Fondo',
  style: 'Stile',
  elements: 'Elementi',
  frame: 'Cornice',
};

export const BUILDER_MODAL_STYLES = `
:root { --ai-teal:#278e8e; --ai-teal-d:#1f7373; --ai-gold:#b9a06a; }
#${MODAL_ID} .modal-title{ font-weight:700; }
#${MODAL_ID} .ai-bgb-tabs{ display:flex; gap:6px; padding:12px 24px 0; border-bottom:1px solid #e6ecec; }
#${MODAL_ID} .ai-bgb-tab{ display:inline-flex; align-items:center; border:1px solid #e3e3e3; border-bottom:none; border-radius:10px 10px 0 0; background:#fafafa; color:#546464; font-size:12.5px; font-weight:700; text-transform:uppercase; letter-spacing:.5px; padding:8px 16px; cursor:pointer; }
#${MODAL_ID} .ai-bgb-tab.active{ background:#f0fbfb; color:var(--ai-teal-d); border-color:var(--ai-teal); }
#${MODAL_ID} .ai-bgb-tab-n{ display:inline-flex; align-items:center; justify-content:center; width:17px; height:17px; margin-right:7px; border-radius:50%; background:#dbe6e6; color:#546464; font-size:10px; font-weight:800; letter-spacing:0; }
#${MODAL_ID} .ai-bgb-tab.active .ai-bgb-tab-n{ background:var(--ai-teal); color:#fff; }
#${MODAL_ID} .ai-bgb-body{ padding:14px 24px 8px; }
#${MODAL_ID} .ai-bgb-head{ margin:2px 0 14px; }
#${MODAL_ID} .ai-bgb-head-t{ font-size:17px; font-weight:800; color:#2c3a3a; margin:0 0 3px; }
#${MODAL_ID} .ai-bgb-head-s{ font-size:12.5px; color:#8a9a9a; line-height:1.4; }
#${MODAL_ID} .ai-bgb-lbl{ font-size:12px; text-transform:uppercase; letter-spacing:.6px; color:#7a8a8a; font-weight:700; margin:14px 0 8px; }
#${MODAL_ID} .ai-bgb-sublbl{ font-size:11px; text-transform:uppercase; letter-spacing:.5px; color:#a8b4b4; font-weight:700; margin:10px 0 6px; }
#${MODAL_ID} .ai-bgb-hint{ font-size:12px; color:#8a9a9a; margin-top:6px; }
#${MODAL_ID} .ai-bgb-cards3{ display:grid; grid-template-columns:repeat(3,1fr); gap:10px; }
#${MODAL_ID} .ai-bgb-cards4{ display:grid; grid-template-columns:repeat(4,1fr); gap:10px; }
#${MODAL_ID} .ai-bgb-cards5{ display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); gap:10px; }
#${MODAL_ID} .ai-bgb-card{ border:1px solid #e3e3e3; border-radius:9px; padding:6px 6px; text-align:center; cursor:pointer; background:#fafafa; transition:.12s; }
#${MODAL_ID} .ai-bgb-card:hover{ border-color:#bfe0e0; }
#${MODAL_ID} .ai-bgb-card.active{ border-color:var(--ai-teal); background:#f0fbfb; box-shadow:0 0 0 2px rgba(39,142,142,.18); }
#${MODAL_ID} .ai-bgb-card-ic{ display:block; line-height:1.2; color:#546464; padding:4px 0; }
#${MODAL_ID} .ai-bgb-card-ic svg{ display:inline-block; }
#${MODAL_ID} .ai-bgb-card-img{ display:block; max-width:100%; max-height:104px; object-fit:contain; border-radius:5px; margin:0 auto 4px; }
#${MODAL_ID} .ai-bgb-frame-box .ai-bgb-card-img{ width:100%; height:100%; max-height:none; object-fit:cover; margin:0; border-radius:0; }
#${MODAL_ID} .ai-bgb-card-img.broken{ display:none; }
#${MODAL_ID} .ai-bgb-card-t{ font-size:11.5px; color:#3a4a4a; }
/* Voce «Personalizzata» in coda ai gruppi a card: riquadro tratteggiato con
   etichetta centrata (stretch della griglia dà l’altezza quando condivide la
   riga con card fotografiche; da sola resta un riquadro compatto). */
#${MODAL_ID} .ai-bgb-card-custom{ display:flex; align-items:center; justify-content:center; min-height:64px; border-style:dashed; border-color:#b4b9c2; }
/* Card «tipo di fondo»: anteprime più grandi con un’ombra morbida dietro; lo
   swatch è il foglio bianco che sostituisce l’immagine per «Sfondo bianco». */
#${MODAL_ID} .ai-bgb-card[data-essence]{ padding:12px 10px 8px; }
#${MODAL_ID} .ai-bgb-card[data-essence] .ai-bgb-card-img{ max-height:150px; }
#${MODAL_ID} .ai-bgb-card[data-essence] .ai-bgb-card-img,
#${MODAL_ID} .ai-bgb-card[data-essence] .ai-bgb-swatch{ box-shadow:0 3px 12px rgba(0,0,0,.14); }
#${MODAL_ID} .ai-bgb-swatch{ display:block; margin:0 auto 4px; border-radius:6px; }
#${MODAL_ID} .ai-bgb-swatch-plain{ width:min(200px,100%); height:150px; background:#fff; border:1px solid #e6e8ea; box-sizing:border-box; }
/* Card fotografiche: la thumbnail riempie l'intera card e il nome scivola in
   un overlay in basso, così l'immagine si giudica a colpo d'occhio. Gli asset
   sono normalizzati full-bleed (scripts di normalizzazione in repo history);
   le essenze seguono il formato del manifesto via --ai-bgb-ratio. */
#${MODAL_ID} .ai-bgb-card.has-thumb,
#${MODAL_ID} .ai-bgb-card.has-swatch{ position:relative; padding:0; overflow:hidden; aspect-ratio:4 / 3; }
#${MODAL_ID} .ai-bgb-card[data-essence].has-thumb,
#${MODAL_ID} .ai-bgb-card[data-essence].has-swatch{ aspect-ratio:var(--ai-bgb-ratio, 3 / 4); }
#${MODAL_ID} .ai-bgb-card.has-thumb .ai-bgb-card-img{ position:absolute; inset:0; width:100%; height:100%; max-height:none; object-fit:cover; margin:0; border-radius:0; box-shadow:none; }
#${MODAL_ID} .ai-bgb-card.has-thumb .ai-bgb-card-t{ position:absolute; left:0; right:0; bottom:0; z-index:1; padding:18px 8px 6px; color:#fff; font-weight:600; font-size:12px; text-shadow:0 1px 2px rgba(0,0,0,.55); background:linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,.55)); }
#${MODAL_ID} .ai-bgb-card.has-swatch .ai-bgb-swatch{ position:absolute; inset:0; width:100%; height:100%; margin:0; border:none; border-radius:0; box-shadow:none; }
#${MODAL_ID} .ai-bgb-card.has-swatch .ai-bgb-card-t{ position:absolute; left:0; right:0; bottom:0; z-index:1; padding:18px 8px 6px; font-weight:600; font-size:12px; background:linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,.85)); }
#${MODAL_ID} .ai-bgb-chips{ display:flex; gap:8px; flex-wrap:wrap; }
#${MODAL_ID} .ai-bgb-chip{ border:1px solid #e3e3e3; border-radius:16px; padding:5px 12px; font-size:12.5px; color:#546464; cursor:pointer; background:#fafafa; }
#${MODAL_ID} .ai-bgb-chip.active{ border-color:var(--ai-teal); background:#f0fbfb; color:var(--ai-teal-d); font-weight:600; }
#${MODAL_ID} .ai-bgb-atmo-row{ display:flex; gap:14px; flex-wrap:wrap; }
#${MODAL_ID} .ai-bgb-atmo{ text-align:center; cursor:pointer; width:74px; }
#${MODAL_ID} .ai-bgb-sw{ width:44px; height:44px; border-radius:50%; margin:0 auto 5px; box-shadow:0 0 0 1px #d8d8d8; }
#${MODAL_ID} .ai-bgb-atmo.active .ai-bgb-sw{ box-shadow:0 0 0 3px var(--ai-teal); }
#${MODAL_ID} .ai-bgb-atmo-t{ font-size:11.5px; color:#546464; line-height:1.2; }
#${MODAL_ID} .ai-bgb-gradient-grid{ display:grid; grid-template-columns:auto 1fr; gap:0 22px; align-items:start; }
#${MODAL_ID} .ai-bgb-grad-spot{ position:absolute; width:26px; height:26px; border-radius:50%; border:1px solid #cfe0e0; background:rgba(255,255,255,.85); color:#546464; font-size:13px; line-height:1; cursor:pointer; padding:0; z-index:3; display:flex; align-items:center; justify-content:center; }
#${MODAL_ID} .ai-bgb-grad-spot:hover{ border-color:var(--ai-teal); color:var(--ai-teal-d); }
#${MODAL_ID} .ai-bgb-grad-spot.active{ border-color:var(--ai-teal); background:var(--ai-teal); color:#fff; box-shadow:0 0 0 2px rgba(39,142,142,.25); }
#${MODAL_ID} .gs-top{ top:4px; left:50%; transform:translateX(-50%); }
#${MODAL_ID} .gs-bottom{ bottom:4px; left:50%; transform:translateX(-50%); }
#${MODAL_ID} .gs-left{ left:4px; top:50%; transform:translateY(-50%); }
#${MODAL_ID} .gs-right{ right:4px; top:50%; transform:translateY(-50%); }
#${MODAL_ID} .gs-top-left{ top:4px; left:4px; }
#${MODAL_ID} .gs-top-right{ top:4px; right:4px; }
#${MODAL_ID} .gs-bottom-left{ bottom:4px; left:4px; }
#${MODAL_ID} .gs-bottom-right{ bottom:4px; right:4px; }
#${MODAL_ID} .gs-edges{ top:50%; left:50%; transform:translate(-50%,-50%); }
/* 640px: abbastanza da coprire anche le diagonali del foglio ingrandito del
   pannello sfumato; il surplus lo taglia l'overflow:hidden del foglio. */
#${MODAL_ID} .ai-bgb-grad-bar{ position:absolute; width:640px; height:24px; margin:0; padding:0; border:none; background:none; cursor:grab; z-index:4; }
#${MODAL_ID} .ai-bgb-grad-bar:active{ cursor:grabbing; }
#${MODAL_ID} .ai-bgb-grad-bar::before{ content:''; position:absolute; left:0; right:0; top:50%; height:2px; margin-top:-1px; background:var(--ai-teal); box-shadow:0 0 0 1px rgba(255,255,255,.55); }
/* La maniglia è una pillola con la doppia freccia nel verso del flusso (ruota
   con la barra): dichiara il trascinamento che il pomello tondo non diceva. */
#${MODAL_ID} .ai-bgb-grad-grip{ position:absolute; left:50%; top:50%; width:36px; height:20px; margin:-10px 0 0 -18px; border-radius:10px; border:2px solid #fff; background:var(--ai-teal); box-shadow:0 1px 4px rgba(0,0,0,.3); display:flex; align-items:center; justify-content:center; transition:transform .12s, box-shadow .12s; }
#${MODAL_ID} .ai-bgb-grad-grip::after{ content:'⇅'; color:#fff; font-size:12px; line-height:1; font-style:normal; }
#${MODAL_ID} .ai-bgb-grad-bar:hover .ai-bgb-grad-grip{ transform:scale(1.08); box-shadow:0 2px 7px rgba(0,0,0,.4); }
#${MODAL_ID} .ai-bgb-grad-ring{ position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); border:2px dashed var(--ai-teal); border-radius:50%; background:rgba(39,142,142,.06); box-shadow:0 0 0 1px rgba(255,255,255,.4); cursor:grab; padding:0; z-index:4; }
#${MODAL_ID} .ai-bgb-adv{ display:inline-flex; align-items:center; gap:6px; margin-top:12px; font-size:12px; color:#6a7a7a; cursor:pointer; user-select:none; }
#${MODAL_ID} .ai-bgb-adv input{ margin:0; cursor:pointer; }
#${MODAL_ID} .ai-bgb-adv-hint{ font-size:11px; color:#9aabab; margin-top:3px; max-width:240px; }
#${MODAL_ID} .ai-bgb-color-row{ display:flex; align-items:center; gap:14px; }
#${MODAL_ID} .ai-bgb-color-dot{ border:none; background:none; padding:0; text-align:center; cursor:pointer; }
#${MODAL_ID} .ai-bgb-color-dot .ai-bgb-sw{ display:block; margin:0 auto 5px; }
#${MODAL_ID} .ai-bgb-color-dot:hover .ai-bgb-sw{ box-shadow:0 0 0 3px var(--ai-teal); }
#${MODAL_ID} .ai-bgb-color-dot-t{ font-size:11.5px; color:#546464; }
#${MODAL_ID} .ai-bgb-color-arrow{ color:#8a9a9a; font-size:16px; }
#${MODAL_ID} .ai-bgb-color-overlay{ position:fixed; inset:0; z-index:2000; display:flex; align-items:center; justify-content:center; outline:none; }
#${MODAL_ID} .ai-bgb-color-overlay-backdrop{ position:absolute; inset:0; background:rgba(30,40,40,.45); }
#${MODAL_ID} .ai-bgb-color-overlay-card{ position:relative; width:min(560px, calc(100vw - 40px)); max-height:min(640px, calc(100vh - 40px)); overflow:auto; background:#fff; border-radius:10px; box-shadow:0 12px 40px rgba(0,0,0,.35); padding:16px 20px 14px; }
#${MODAL_ID} .ai-bgb-color-overlay-t{ font-size:15px; font-weight:800; color:#2c3a3a; margin-bottom:6px; }
#${MODAL_ID} .ai-bgb-color-tones{ display:flex; gap:10px; flex-wrap:wrap; }
#${MODAL_ID} .ai-bgb-color-tone{ border:none; background:none; padding:0; width:64px; text-align:center; cursor:pointer; }
#${MODAL_ID} .ai-bgb-color-tone .ai-bgb-sw{ display:block; width:34px; height:34px; margin:0 auto 4px; }
#${MODAL_ID} .ai-bgb-color-tone:hover .ai-bgb-sw{ box-shadow:0 0 0 3px var(--ai-teal); }
#${MODAL_ID} .ai-bgb-color-tone-t{ font-size:10.5px; color:#546464; line-height:1.15; display:block; }
#${MODAL_ID} .ai-bgb-color-picker-mount{ margin:4px 0 8px; }
#${MODAL_ID} .ai-bgb-color-overlay-foot{ display:flex; justify-content:flex-end; gap:8px; margin-top:8px; }
#${MODAL_ID} .ai-bgb-color-apply{ background:var(--ai-teal); border-color:var(--ai-teal); color:#fff; font-weight:600; }
#${MODAL_ID} .ai-bgb-color-apply:hover{ background:var(--ai-teal-d); border-color:var(--ai-teal-d); color:#fff; }
#${MODAL_ID} .ai-bgb-tone .ai-bgb-sw-sm{ width:30px; height:30px; }
#${MODAL_ID} .ai-bgb-tone{ width:58px; }
#${MODAL_ID} .ai-bgb-scene-band{ opacity:.35; }
#${MODAL_ID} .ai-bgb-scene-band.has-art{ opacity:.85; }
#${MODAL_ID} .ai-bgb-band-ui{ z-index:4; }
#${MODAL_ID} .ai-bgb-band-ui .ai-bgb-band-handle{ pointer-events:auto; position:absolute; background:var(--ai-teal); color:#fff; border:none; border-radius:12px; font-size:11px; font-weight:700; padding:2px 10px; cursor:grab; }
#${MODAL_ID} .pos-bottom .ai-bgb-band-handle{ top:-11px; left:50%; transform:translateX(-50%); cursor:ns-resize; }
#${MODAL_ID} .pos-top .ai-bgb-band-handle{ bottom:-11px; left:50%; transform:translateX(-50%); cursor:ns-resize; }
#${MODAL_ID} .pos-left .ai-bgb-band-handle{ right:-16px; top:50%; transform:translateY(-50%); cursor:ew-resize; }
#${MODAL_ID} .pos-right .ai-bgb-band-handle{ left:-16px; top:50%; transform:translateY(-50%); cursor:ew-resize; }
#${MODAL_ID} .ai-bgb-band-ui .ai-bgb-band-fade{ pointer-events:auto; position:absolute; right:6px; bottom:6px; border:1px solid rgba(255,255,255,.8); background:rgba(255,255,255,.7); color:#3a4a4a; border-radius:10px; font-size:10px; padding:1px 8px; cursor:pointer; }
#${MODAL_ID} .pos-top .ai-bgb-band-fade{ bottom:auto; top:6px; }
#${MODAL_ID} .sw-none{ background:#ffffff; }
#${MODAL_ID} .sw-avorio{ background:linear-gradient(135deg,#f7f1e3,#e7d8ba); }
#${MODAL_ID} .sw-azzurro{ background:linear-gradient(135deg,#dceef8,#9fcfe6); }
#${MODAL_ID} .sw-tramonto{ background:linear-gradient(135deg,#f8dcb4,#e79e86); }
#${MODAL_ID} .sw-notte{ background:linear-gradient(135deg,#2a3658,#46598f); }
#${MODAL_ID} .sw-perla{ background:linear-gradient(135deg,#eeeef2,#cdced6); }
#${MODAL_ID} .sw-salvia{ background:linear-gradient(135deg,#dde8d8,#a9bfa2); }
#${MODAL_ID} .sw-lavanda{ background:linear-gradient(135deg,#e4dcf0,#b6a8cf); }
#${MODAL_ID} .sw-rosa{ background:linear-gradient(135deg,#f1dcdd,#d8a7ab); }
#${MODAL_ID} .sw-tortora{ background:linear-gradient(135deg,#ece4d8,#c6b8a6); }
#${MODAL_ID} .sw-oro{ background:linear-gradient(135deg,#f2e9cb,#d9c48a); }
/* Pallino «Personalizzata» in coda alla riga palette: tratteggiato, senza
   colore, sullo stesso box-sizing degli swatch pieni. */
#${MODAL_ID} .sw-custom{ box-sizing:border-box; background:#fff; border:2px dashed #b4b9c2; }
#${MODAL_ID} .ai-bgb-frame-row{ display:flex; gap:12px; flex-wrap:wrap; }
#${MODAL_ID} .ai-bgb-frame{ text-align:center; cursor:pointer; width:116px; }
#${MODAL_ID} .ai-bgb-frame-box{ width:104px; height:74px; margin:0 auto 5px; background:#fdfbf5; }
#${MODAL_ID} .ai-bgb-frame.active .ai-bgb-frame-box{ outline:2px solid var(--ai-teal); outline-offset:2px; }
#${MODAL_ID} .ai-bgb-frame-t{ font-size:11px; color:#6a7474; line-height:1.2; }
#${MODAL_ID} .fr-none{ border:1px dashed #cfcfcf; }
#${MODAL_ID} .fr-thin{ border:1px solid var(--ai-gold); }
#${MODAL_ID} .fr-classic{ border:3px double var(--ai-gold); }
#${MODAL_ID} .fr-floral{ border:3px double var(--ai-gold); box-shadow:inset 0 0 0 1px var(--ai-gold); }
#${MODAL_ID} .fr-rich{ border:5px double var(--ai-gold); box-shadow:inset 0 0 0 1px var(--ai-gold), 0 0 0 1px var(--ai-gold); }
#${MODAL_ID} .fr-silver{ border:1px solid #b4b9c2; }
#${MODAL_ID} .fr-neoclassic{ border:3px double var(--ai-gold); box-shadow:inset 0 0 0 2px #fdfbf5, inset 0 0 0 3px var(--ai-gold); }
#${MODAL_ID} .fr-acanthus{ border:4px double var(--ai-gold); box-shadow:inset 0 0 0 1px var(--ai-gold); }
#${MODAL_ID} .fr-deco{ border:3px solid var(--ai-gold); box-shadow:inset 0 0 0 3px #fdfbf5, inset 0 0 0 4px var(--ai-gold); }
#${MODAL_ID} .fr-marble{ border:4px solid #c4c4cc; }
#${MODAL_ID} .fr-wood{ border:4px solid #7a5230; }
#${MODAL_ID} .fr-custom{ border:2px dashed #b4b9c2; }
#${MODAL_ID} .fr-vignette{ box-shadow:inset 0 0 20px rgba(40,44,52,.35); }
#${MODAL_ID} .fr-wash{ box-shadow:inset 0 0 16px rgba(150,160,180,.45); }
#${MODAL_ID} .fr-dissolve{ box-shadow:inset 0 0 18px 6px rgba(255,255,255,.9); }
#${MODAL_ID} .fr-mat{ border:8px solid #efece3; box-shadow:inset 0 0 0 9px #efece3; }
#${MODAL_ID} .fr-photoline{ border:2px solid #555; }
#${MODAL_ID} .fr-softshadow{ box-shadow:inset 0 0 13px rgba(0,0,0,.28); }
#${MODAL_ID} .ai-bgb-frame-custom,
#${MODAL_ID} .ai-bgb-coverage-custom,
#${MODAL_ID} .ai-bgb-custom-input{ width:100%; box-sizing:border-box; padding:6px 8px; font-size:13px; border:1px solid #d9d9d9; border-radius:6px; margin:4px 0 8px; }
#${MODAL_ID} .ai-bgb-tool-flex{ display:flex; gap:18px; align-items:flex-start; }
#${MODAL_ID} .ai-bgb-tool-flex > .ai-bgb-hint{ flex:1; margin-top:0; max-width:280px; }
#${MODAL_ID} .ai-bgb-tool-wrap{ flex:none; width:285px; max-width:100%; }
#${MODAL_ID} .ai-bgb-tool-wrap .ai-bgb-sheet{ max-width:285px; max-height:380px; margin:0; }
/* Solo nel pannello sfumato il foglio cresce: pareggia l'altezza della
   colonna «Intensità + Colore di arrivo» e dà respiro alla barra. */
#${MODAL_ID} .ai-bgb-gradient-grid .ai-bgb-tool-wrap{ width:340px; }
#${MODAL_ID} .ai-bgb-gradient-grid .ai-bgb-tool-wrap .ai-bgb-sheet{ max-width:340px; max-height:500px; }
#${MODAL_ID} .ai-bgb-elements-side{ flex:1; min-width:0; }
#${MODAL_ID} .ai-bgb-sheet{ position:relative; width:100%; max-width:340px; max-height:380px; margin:0 auto; background:var(--bgb-tint-soft); border:1px solid #e0e0e0; border-radius:4px; overflow:hidden; }
#${MODAL_ID} .ess-scene{ background:linear-gradient(180deg, var(--bgb-tint), var(--bgb-tint-soft)); }
#${MODAL_ID} .ai-bgb-scene-bg{ position:absolute; inset:0; background-size:cover; background-position:center; opacity:.5; pointer-events:none; }
#${MODAL_ID} .ai-bgb-grid{ position:absolute; inset:0; display:grid; grid-template-columns:24% 52% 24%; grid-template-rows:24% 52% 24%; grid-template-areas:'tl top tr' 'left center right' 'bl bottom br'; }
#${MODAL_ID} .ai-bgb-zone{ display:flex; align-items:center; justify-content:center; font-size:20px; }
#${MODAL_ID} .z-tl{ grid-area:tl; } #${MODAL_ID} .z-top{ grid-area:top; } #${MODAL_ID} .z-tr{ grid-area:tr; }
#${MODAL_ID} .z-left{ grid-area:left; } #${MODAL_ID} .z-right{ grid-area:right; }
#${MODAL_ID} .z-bl{ grid-area:bl; } #${MODAL_ID} .z-bottom{ grid-area:bottom; } #${MODAL_ID} .z-br{ grid-area:br; }
#${MODAL_ID} .ai-bgb-center{ grid-area:center; display:flex; align-items:center; justify-content:center; border:1px dashed rgba(120,130,130,.45); border-radius:4px; margin:4px; color:#8a9a9a; font-size:11px; text-transform:uppercase; letter-spacing:.5px; background:rgba(255,255,255,.35); text-align:center; }
#${MODAL_ID} .ai-bgb-place-area{ position:absolute; border:1px dashed rgba(39,142,142,.55); background:rgba(39,142,142,.08); cursor:pointer; padding:0; z-index:3; }
#${MODAL_ID} .ai-bgb-place-area:hover{ background:rgba(39,142,142,.18); }
#${MODAL_ID} .ai-bgb-place-area.active{ border-style:solid; box-shadow:0 0 0 2px rgba(39,142,142,.25); }
#${MODAL_ID} .pa-full{ left:30%; top:30%; width:40%; height:40%; border-radius:8px; }
#${MODAL_ID} .pa-left{ left:0; top:0; bottom:0; width:16%; }
#${MODAL_ID} .pa-right{ right:0; top:0; bottom:0; width:16%; }
#${MODAL_ID} .pa-top{ top:0; left:16%; right:16%; height:16%; }
#${MODAL_ID} .pa-bottom{ bottom:0; left:16%; right:16%; height:16%; }
#${MODAL_ID} .mode-cells .ai-bgb-scene-bg{ opacity:.18; }
#${MODAL_ID} .mode-cells .ai-bgb-scene-band{ opacity:.15; }
#${MODAL_ID} .ai-bgb-zone{ cursor:pointer; border-radius:6px; outline:1px dashed rgba(39,142,142,.35); outline-offset:-3px; }
#${MODAL_ID} .ai-bgb-zone:hover{ background:rgba(39,142,142,.12); }
#${MODAL_ID} .ai-bgb-zone.disabled{ cursor:not-allowed; opacity:.35; outline-style:dotted; }
#${MODAL_ID} .ai-bgb-extras{ border-top:1px solid #e6ecec; margin-top:14px; padding-top:6px; }
#${MODAL_ID} .ai-bgb-zone.occupied{ background:rgba(255,255,255,.45); border-radius:8px; box-shadow:inset 0 0 0 1px rgba(39,142,142,.25); }
#${MODAL_ID} .ai-bgb-zone-plus{ font-size:15px; color:#9fb4b4; opacity:0; transition:.12s; pointer-events:none; }
#${MODAL_ID} .ai-bgb-zone.free:hover .ai-bgb-zone-plus{ opacity:.9; }
#${MODAL_ID} .ai-bgb-zone.sel{ background:rgba(39,142,142,.18); box-shadow:inset 0 0 0 2px var(--ai-teal); border-radius:6px; }
#${MODAL_ID} .ai-bgb-zone.grouped{ background:rgba(255,255,255,.45); box-shadow:inset 0 0 0 1px rgba(39,142,142,.25); }
#${MODAL_ID} .ai-bgb-zone.rejected{ animation:ai-bgb-shake .25s; }
@keyframes ai-bgb-shake{ 25%{ transform:translateX(-3px);} 75%{ transform:translateX(3px);} }
#${MODAL_ID} .ai-bgb-frame-overlay{ position:absolute; inset:6px; pointer-events:none; z-index:1; }
#${MODAL_ID} .ai-bgb-frame-overlay .c{ display:none; }
#${MODAL_ID} .cov-top-bottom .ai-bgb-frame-overlay{ border-left:none !important; border-right:none !important; box-shadow:none !important; }
#${MODAL_ID} .cov-corners .ai-bgb-frame-overlay{ border:none !important; box-shadow:none !important; }
#${MODAL_ID} .cov-corners .ai-bgb-frame-overlay .c{ display:block; position:absolute; width:22px; height:22px; border:2px solid var(--ai-gold); }
#${MODAL_ID} .cov-corners .c-tl{ top:0; left:0; border-right:none; border-bottom:none; }
#${MODAL_ID} .cov-corners .c-tr{ top:0; right:0; border-left:none; border-bottom:none; }
#${MODAL_ID} .cov-corners .c-bl{ bottom:0; left:0; border-right:none; border-top:none; }
#${MODAL_ID} .cov-corners .c-br{ bottom:0; right:0; border-left:none; border-top:none; }
#${MODAL_ID} .cov-sides .ai-bgb-frame-overlay{ border-top:none !important; border-bottom:none !important; box-shadow:none !important; }
#${MODAL_ID} .cov-c-left .ai-bgb-frame-overlay{ border-right:none !important; box-shadow:none !important; }
#${MODAL_ID} .cov-c-right .ai-bgb-frame-overlay{ border-left:none !important; box-shadow:none !important; }
#${MODAL_ID} .cov-u .ai-bgb-frame-overlay{ border-top:none !important; box-shadow:none !important; }
#${MODAL_ID} .cov-arch .ai-bgb-frame-overlay{ border-bottom:none !important; box-shadow:none !important; }
#${MODAL_ID} .ai-bgb-contain-mat{ position:absolute; inset:0; border:12px solid rgba(255,255,255,.94); box-sizing:border-box; pointer-events:none; z-index:1; }
#${MODAL_ID} .ai-bgb-contain-mat .c{ display:none; }
#${MODAL_ID} .cov-top-bottom .ai-bgb-contain-mat{ border-left:none; border-right:none; }
#${MODAL_ID} .cov-sides .ai-bgb-contain-mat{ border-top:none; border-bottom:none; }
#${MODAL_ID} .cov-c-left .ai-bgb-contain-mat{ border-right:none; }
#${MODAL_ID} .cov-c-right .ai-bgb-contain-mat{ border-left:none; }
#${MODAL_ID} .cov-u .ai-bgb-contain-mat{ border-top:none; }
#${MODAL_ID} .cov-arch .ai-bgb-contain-mat{ border-bottom:none; }
#${MODAL_ID} .cov-corners .ai-bgb-contain-mat{ border:none; }
#${MODAL_ID} .cov-corners .ai-bgb-contain-mat .c{ display:block; position:absolute; width:28px; height:28px; background:rgba(255,255,255,.94); }
#${MODAL_ID} .cov-corners .ai-bgb-contain-mat .c-tl{ top:0; left:0; }
#${MODAL_ID} .cov-corners .ai-bgb-contain-mat .c-tr{ top:0; right:0; }
#${MODAL_ID} .cov-corners .ai-bgb-contain-mat .c-bl{ bottom:0; left:0; }
#${MODAL_ID} .cov-corners .ai-bgb-contain-mat .c-br{ bottom:0; right:0; }
#${MODAL_ID} .ai-bgb-margin-row{ display:flex; align-items:center; gap:8px; margin:4px 0; }
#${MODAL_ID} .ai-bgb-lbl-sm{ font-size:11px; color:#6a7474; width:64px; }
#${MODAL_ID} .ai-bgb-element-row{ display:flex; align-items:center; justify-content:space-between; border:1px solid #e3e3e3; border-radius:8px; padding:6px 10px; margin-bottom:6px; font-size:13px; background:#fafafa; }
#${MODAL_ID} .ai-bgb-element-row .ai-bgb-icon{ vertical-align:-3px; margin-right:4px; }
#${MODAL_ID} .ai-bgb-custom-row{ display:flex; gap:8px; }
#${MODAL_ID} .ai-bgb-picker-foot{ display:flex; gap:8px; margin-top:12px; }
#${MODAL_ID} .ai-bgb-prompt{ font-family:monospace; font-size:12.5px; }
#${MODAL_ID} .ai-bgb-exp{ margin-top:8px; font-size:12.5px; color:#546464; }
#${MODAL_ID} .ai-bgb-exp summary{ cursor:pointer; font-size:12px; text-transform:uppercase; letter-spacing:.5px; color:#90a0a0; font-weight:700; }
#${MODAL_ID} .ai-bgb-exp textarea{ margin-top:6px; }
/* Con la colonna anteprima il modal-xl di Bootstrap (1140px) va stretto:
   sugli schermi larghi si prende più spazio, così i pannelli respirano e
   l'anteprima orizzontale non resta francobollo. Sotto i 1200px valgono le
   larghezze responsive native di Bootstrap. */
@media (min-width:1200px){
  #${MODAL_ID} .modal-dialog.modal-xl{ max-width:min(1400px, calc(100vw - 48px)); }
}
#${MODAL_ID} .ai-bgb-cols{ display:flex; gap:20px; align-items:flex-start; }
#${MODAL_ID} .ai-bgb-main{ flex:1 1 auto; min-width:0; }
#${MODAL_ID} .ai-bgb-side{ flex:0 0 340px; position:sticky; top:12px; }
#${MODAL_ID} .ai-bgb-side > .ai-bgb-lbl{ margin-top:2px; }
#${MODAL_ID} .ai-bgb-preview-box{ position:relative; width:100%; border:1px solid #e3e3e3; border-radius:8px; background:#fafafa; overflow:hidden; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="empty"]{ border-style:dashed; }
#${MODAL_ID} .ai-bgb-preview-empty{ display:none; position:absolute; inset:0; align-items:center; justify-content:center; text-align:center; font-size:12px; color:#8a9a9a; padding:18px; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="empty"] .ai-bgb-preview-empty{ display:flex; }
#${MODAL_ID} .ai-bgb-preview-stage{ position:absolute; inset:0; }
#${MODAL_ID} .ai-bgb-preview-stage img{ position:absolute; inset:0; width:100%; height:100%; object-fit:cover; transition:opacity .3s ease; }
#${MODAL_ID} .ai-bgb-preview-stage img.entering{ opacity:0; }
#${MODAL_ID} .ai-bgb-preview-stage::after{ content:''; position:absolute; inset:0; background:rgba(255,255,255,.45); opacity:0; transition:opacity .25s; pointer-events:none; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="stale"] .ai-bgb-preview-stage::after,
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="loading"] .ai-bgb-preview-stage::after{ opacity:1; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="stale"] .ai-bgb-preview-stage img{ filter:grayscale(.35); }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="stale"] .ai-bgb-preview-stage{ cursor:pointer; }
#${MODAL_ID} .ai-bgb-preview-badge{ display:none; position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); border:none; border-radius:14px; background:rgba(44,58,58,.85); color:#fff; font-size:11.5px; font-weight:700; letter-spacing:.3px; padding:5px 12px; cursor:pointer; z-index:3; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="stale"] .ai-bgb-preview-badge{ display:block; animation:ai-bgb-badge-in .15s ease-out; }
@keyframes ai-bgb-badge-in{ from{ opacity:0; transform:translate(-50%,-50%) scale(.9); } }
#${MODAL_ID} .ai-bgb-preview-run-hot{ background:var(--ai-teal); border-color:var(--ai-teal); color:#fff; font-weight:600; }
#${MODAL_ID} .ai-bgb-preview-run-hot:hover{ background:var(--ai-teal-d); border-color:var(--ai-teal-d); color:#fff; }
#${MODAL_ID} .ai-bgb-preview-shimmer{ display:none; position:absolute; inset:0; overflow:hidden; pointer-events:none; z-index:2; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="loading"] .ai-bgb-preview-shimmer{ display:block; }
#${MODAL_ID} .ai-bgb-preview-shimmer::before{ content:''; position:absolute; top:-20%; bottom:-20%; width:45%; left:-45%; transform:skewX(-18deg); background:linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.55),rgba(255,255,255,0)); animation:ai-bgb-shimmer 1.2s linear infinite; }
@keyframes ai-bgb-shimmer{ to{ left:145%; } }
/* Avanzamento della generazione: tarato sulla durata mediana osservata
   (~20s). In quel tempo la barra arriva quasi in fondo con un easing
   realistico; se la generazione sfora, striscia lentamente senza mai
   promettere il 100%. Si riavvia da sola: uscendo dallo stato loading la
   track torna display:none e l'animazione del figlio si azzera. */
#${MODAL_ID} .ai-bgb-preview-progress{ display:none; position:absolute; left:0; right:0; bottom:0; height:3px; background:rgba(39,142,142,.15); z-index:3; }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="loading"] .ai-bgb-preview-progress{ display:block; }
#${MODAL_ID} .ai-bgb-preview-progress-fill{ display:block; height:100%; width:0; background:var(--ai-teal); }
#${MODAL_ID} .ai-bgb-preview-box[data-preview-state="loading"] .ai-bgb-preview-progress-fill{ animation:ai-bgb-preview-progress 20s ease-out forwards, ai-bgb-preview-progress-tail 40s linear 20s forwards; }
@keyframes ai-bgb-preview-progress{ 0%{ width:0; } 55%{ width:64%; } 100%{ width:88%; } }
@keyframes ai-bgb-preview-progress-tail{ from{ width:88%; } to{ width:97%; } }
#${MODAL_ID} .ai-bgb-preview-bar{ margin-top:10px; }
#${MODAL_ID} .ai-bgb-preview-bar .ai-bgb-preview-run{ width:100%; }
#${MODAL_ID} .ai-bgb-preview-status{ font-size:12px; color:#b3524a; margin-top:6px; }
#${MODAL_ID} .ai-bgb-preview-status:empty{ display:none; }
@media (max-width:991.98px){
  #${MODAL_ID} .ai-bgb-cols{ flex-direction:column; }
  #${MODAL_ID} .ai-bgb-side{ position:static; flex:none; width:100%; }
  #${MODAL_ID} .ai-bgb-side .ai-bgb-preview-box{ max-width:340px; }
}
#${MODAL_ID} .ai-bgb-foot{ display:flex; align-items:center; }
#${MODAL_ID} .ai-bgb-credits{ font-size:12.5px; color:#7a8585; margin-right:auto; }
#${MODAL_ID} .ai-bgb-generate,
#${MODAL_ID} .ai-bgb-next{ background:var(--ai-teal); border-color:var(--ai-teal); color:#fff; font-weight:600; }
#${MODAL_ID} .ai-bgb-generate:hover,
#${MODAL_ID} .ai-bgb-next:hover{ background:var(--ai-teal-d); border-color:var(--ai-teal-d); color:#fff; }
@media (prefers-reduced-motion: reduce){
  #${MODAL_ID} .ai-bgb-preview-shimmer::before{ animation:none; }
  #${MODAL_ID} .ai-bgb-preview-stage img{ transition:none; }
  #${MODAL_ID} .ai-bgb-preview-stage::after{ transition:none; }
  #${MODAL_ID} .ai-bgb-grad-grip{ transition:none; }
  #${MODAL_ID} .ai-bgb-preview-box[data-preview-state="stale"] .ai-bgb-preview-badge{ animation:none; }
}
`;

// Thumbnail dell’asset di catalogo: solo per le card senza iconOf (line-art),
// la label resta sempre presente subito dopo e fa da fallback tipografico
// se l’immagine non carica (vedi bindThumbFallback in builderModal.js).
const renderCardAsset = (item, iconOf) => {
  if (iconOf) {
    return '';
  }
  // Alcune card (es. «Sfondo bianco») non hanno un’immagine ma uno swatch CSS:
  // così evitiamo una thumbnail fuorviante e restiamo nitidi a ogni dimensione.
  if (item.swatch) {
    return `<span class="ai-bgb-swatch ai-bgb-swatch-${item.swatch}" aria-hidden="true"></span>`;
  }
  return item.asset
    ? `<img class="ai-bgb-card-img" src="${item.asset}" alt="">`
    : '';
};

// Le card con thumbnail (o swatch pieno) portano una classe dedicata: la
// foto riempie la card e la label scivola in overlay. Le card a icona
// restano tipografiche.
const cardKindClass = (item, iconOf) => {
  if (iconOf) {
    return '';
  }
  if (item.swatch) {
    return ' has-swatch';
  }
  return item.asset ? ' has-thumb' : '';
};

const renderCards = (items, dataAttr, iconOf) =>
  items
    .map(
      (item) =>
        `<div class="ai-bgb-card${cardKindClass(item, iconOf)}" ${dataAttr}="${
          item.key
        }">${
          iconOf ? `<span class="ai-bgb-card-ic">${iconOf(item)}</span>` : ''
        }${renderCardAsset(item, iconOf)}<span class="ai-bgb-card-t">${
          item.label
        }</span></div>`
    )
    .join('');

const renderChips = (items, dataAttr) =>
  items
    .map(
      (item) =>
        `<div class="ai-bgb-chip" ${dataAttr}="${item.key}">${item.label}</div>`
    )
    .join('');

// Voce «Personalizzata» delle nove dimensioni che ammettono testo libero
// (spec 2026-08-07-builder-custom-values-design.md): stesso data-attr dei
// preset del gruppo, in coda, così i click handler esistenti in
// builderModal.js la selezionano senza wiring dedicato.
const CUSTOM_LABEL = 'Personalizzata';

// Card tratteggiata, niente thumbnail: nessun asset/swatch, quindi
// cardKindClass (sopra) non le assegna mai has-thumb/has-swatch.
const renderCustomCard = (dataAttr) =>
  `<div class="ai-bgb-card ai-bgb-card-custom" ${dataAttr}="custom"><span class="ai-bgb-card-t">${CUSTOM_LABEL}</span></div>`;

// Chip identica alle altre del gruppo.
const renderCustomChip = (dataAttr) =>
  `<div class="ai-bgb-chip" ${dataAttr}="custom">${CUSTOM_LABEL}</div>`;

// Input di testo libero della voce «Personalizzata»: nascosto finché la
// selezione del gruppo non è 'custom' e mai rivalorizzato col focus attivo
// (builderModal.js, pattern .ai-bgb-frame-custom). La classe condivisa
// ai-bgb-custom-input porta lo stile (vedi BUILDER_MODAL_STYLES, in gruppo
// con .ai-bgb-frame-custom/.ai-bgb-coverage-custom); quella specifica per
// dimensione resta solo per il wiring in builderModal.js.
const renderCustomInput = (cssClass, placeholder) =>
  `<input type="text" class="ai-bgb-custom-input ${cssClass}" maxlength="${CUSTOM_TEXT_MAX_LENGTH}" placeholder="${placeholder}" style="display:none" />`;

// Pallino tratteggiato «Personalizzata» in coda alla riga palette: stesso
// markup .ai-bgb-atmo degli altri, swatch tratteggiato al posto del colore.
const renderPalettes = () =>
  BUILDER_PALETTES.map(
    (p) =>
      `<div class="ai-bgb-atmo" data-palette="${p.key}"><div class="ai-bgb-sw ${p.swatch}"></div><div class="ai-bgb-atmo-t">${p.label}</div></div>`
  ).join('') +
  `<div class="ai-bgb-atmo" data-palette="custom"><div class="ai-bgb-sw sw-custom"></div><div class="ai-bgb-atmo-t">${CUSTOM_LABEL}</div></div>`;

// Una funzione sola, tre istanze nel DOM: essenza carta, sfumato e scena. È
// per questo che il wiring in builderModal.js deve leggere i controlli senza
// scoping: sono copie dello stesso catalogo e devono restare allineate.
const renderPaperPicker = () => `
  <div class="ai-bgb-lbl">Tipo di carta</div>
  <div class="ai-bgb-cards4">${renderCards(BUILDER_PAPERS, 'data-paper')}</div>
  <div class="ai-bgb-lbl">Grana</div>
  <div class="ai-bgb-chips">${renderChips(PAPER_GRAINS, 'data-grain')}</div>`;

// Sotto sfumato e scena la carta è un’aggiunta, non il fondo: parte spenta e
// si accende a mano, così nessuno sfondo esistente cambia resa da solo.
const renderPaperOption = () => `
  <label class="ai-bgb-adv">
    <input type="checkbox" class="ai-bgb-paper-on" />
    <span>Su carta</span>
  </label>
  <div class="ai-bgb-adv-hint">Stende la grana di un supporto reale sotto tutta l’immagine.</div>
  <div class="ai-bgb-paper-pick" style="display:none">${renderPaperPicker()}</div>`;

const renderMaterialPicker = () => `
  <div class="ai-bgb-lbl">Tipo di materiale</div>
  <div class="ai-bgb-cards3">${renderCards(
    BUILDER_MATERIALS,
    'data-material'
  )}</div>
  <div class="ai-bgb-lbl">Intensità della materia</div>
  <div class="ai-bgb-chips">${renderChips(
    MATERIAL_INTENSITIES,
    'data-material-intensity'
  )}</div>`;

const panelHead = (title, subtitle) =>
  `<div class="ai-bgb-head"><h6 class="ai-bgb-head-t">${title}</h6><div class="ai-bgb-head-s">${subtitle}</div></div>`;

// Rapporto di fallback del riquadro anteprima quando il canvas non fornisce
// le sue misure: le stesse proporzioni delle PREVIEW_SIZES di builderPreview.
const PREVIEW_FALLBACK_RATIOS = {
  horizontal: '432 / 304',
  vertical: '304 / 432',
};

// Colonna anteprima (solo super user): il riquadro tiene sempre il rapporto
// del manifesto, così placeholder, shimmer e immagine non spostano il layout.
const renderPreviewColumn = ({ orientation, ratio }) => `
  <aside class="ai-bgb-side ai-bgb-preview">
    <div class="ai-bgb-lbl">Anteprima</div>
    <div class="ai-bgb-preview-box" data-preview-state="empty" style="aspect-ratio:${
      ratio ||
      PREVIEW_FALLBACK_RATIOS[orientation] ||
      PREVIEW_FALLBACK_RATIOS.vertical
    }">
      <div class="ai-bgb-preview-empty">Genera una bozza rapida per vedere l’effetto delle tue scelte</div>
      <div class="ai-bgb-preview-stage"></div>
      <button type="button" class="ai-bgb-preview-badge">Non aggiornata alle scelte</button>
      <div class="ai-bgb-preview-shimmer" aria-hidden="true"></div>
      <div class="ai-bgb-preview-progress" aria-hidden="true"><i class="ai-bgb-preview-progress-fill"></i></div>
    </div>
    <div class="ai-bgb-preview-bar">
      <button type="button" class="btn btn-light btn-sm ai-bgb-preview-run">Genera anteprima</button>
    </div>
    <div class="ai-bgb-preview-status"></div>
  </aside>`;

const renderBasePanel = (orientation) => `
  ${panelHead(
    'Che tipo di fondo?',
    'Sfondo bianco, sfumatura, scena, carta o materiali. Le anteprime sono solo esempi: colori e dettagli li scegli nei passi successivi.'
  )}
  <div class="ai-bgb-cards5">${renderCards(
    BUILDER_ESSENCES,
    'data-essence'
  )}</div>
  <div class="ai-bgb-sub" data-sub="gradient" style="display:none">
    <div class="ai-bgb-gradient-grid">
      <div>
        <div class="ai-bgb-lbl">Sfumatura</div>
        <div class="ai-bgb-tool-wrap" data-tool="gradient"></div>
        <div class="ai-bgb-hint">Tocca una freccia per la direzione (il cerchio al centro sfuma dai bordi) · trascina la barra (o l’anello) per l’ampiezza</div>
      </div>
      <div>
        <div class="ai-bgb-lbl">Intensità della sfumatura</div>
        <div class="ai-bgb-chips">${renderChips(
          GRADIENT_INTENSITIES,
          'data-gradient-intensity'
        )}</div>
        <label class="ai-bgb-adv" data-sub="mirror">
          <input type="checkbox" class="ai-bgb-mirror" />
          <span>Sfumatura simmetrica</span>
        </label>
        <div class="ai-bgb-adv-hint" data-sub="mirror">Il colore torna ai due lati opposti e il «Colore di arrivo» resta al centro.</div>
        <div class="ai-bgb-lbl">Colori della sfumatura</div>
        <div class="ai-bgb-color-row">
          <button
            type="button"
            class="ai-bgb-color-dot"
            data-color-endpoint="from"
            title="Scegli il colore"
          >
            <span class="ai-bgb-sw"></span>
            <span class="ai-bgb-color-dot-t">Partenza</span>
          </button>
          <span class="ai-bgb-color-arrow" aria-hidden="true">→</span>
          <button
            type="button"
            class="ai-bgb-color-dot"
            data-color-endpoint="to"
            title="Scegli il colore"
          >
            <span class="ai-bgb-sw"></span>
            <span class="ai-bgb-color-dot-t">Arrivo</span>
          </button>
        </div>
      </div>
    </div>
    ${renderPaperOption()}
  </div>
  <div class="ai-bgb-sub" data-sub="paper" style="display:none">
    ${renderPaperPicker()}
    <div class="ai-bgb-hint">La carta vale su tutta la superficie · il colore si sceglie nel passo Stile</div>
  </div>
  <div class="ai-bgb-sub" data-sub="material" style="display:none">
    ${renderMaterialPicker()}
    <div class="ai-bgb-hint">Il materiale ricopre tutta la superficie · colore e atmosfera si scelgono nel passo Stile</div>
  </div>
  <div class="ai-bgb-sub" data-sub="scene" style="display:none">
    <div class="ai-bgb-lbl">Scegli la scena</div>
    <div class="ai-bgb-cards3">${renderCards(
      scenesForOrientation(orientation),
      'data-scene'
    )}${renderCustomCard('data-scene')}</div>
    ${renderCustomInput(
      'ai-bgb-scene-custom',
      'Descrivi la scena: es. ‘un uliveto al tramonto’'
    )}
    <div class="ai-bgb-sub" data-sub="sacred" style="display:none">
      <div class="ai-bgb-lbl">Figura</div>
      <div class="ai-bgb-cards3">
        ${renderCards(SACRED_FIGURES, 'data-sacred-figure')}${renderCustomCard(
  'data-sacred-figure'
)}
      </div>
      ${renderCustomInput(
        'ai-bgb-sacred-figure-custom',
        'Descrivi la figura sacra: es. ‘San Michele Arcangelo’'
      )}
      <div class="ai-bgb-lbl">Inquadratura</div>
      <div class="ai-bgb-chips">
        ${renderChips(
          SACRED_FRAMINGS,
          'data-sacred-framing'
        )}${renderCustomChip('data-sacred-framing')}
      </div>
      ${renderCustomInput(
        'ai-bgb-sacred-framing-custom',
        'Descrivi l’inquadratura: es. ‘primo piano sulle mani giunte’'
      )}
      <div class="ai-bgb-lbl">Prospettiva</div>
      <div class="ai-bgb-chips">
        ${renderChips(
          SACRED_PERSPECTIVES,
          'data-sacred-perspective'
        )}${renderCustomChip('data-sacred-perspective')}
      </div>
      ${renderCustomInput(
        'ai-bgb-sacred-perspective-custom',
        'Descrivi la prospettiva: es. ‘ripresa dal basso, solenne’'
      )}
      <div class="ai-bgb-lbl">Espressione</div>
      <div class="ai-bgb-chips">
        ${renderChips(SACRED_MOODS, 'data-sacred-mood')}${renderCustomChip(
  'data-sacred-mood'
)}
      </div>
      ${renderCustomInput(
        'ai-bgb-sacred-mood-custom',
        'Descrivi l’espressione: es. ‘con lo sguardo rivolto al cielo’'
      )}
    </div>
    <div class="ai-bgb-lbl">Collocazione</div>
    <div class="ai-bgb-tool-flex">
      <div class="ai-bgb-tool-wrap" data-tool="scene"></div>
      <div class="ai-bgb-hint">Tocca il centro per la scena piena o un lato per la fascia · trascina la maniglia per l’ampiezza · il bottone sulla banda alterna dissolvenza e taglio netto</div>
    </div>
    ${renderPaperOption()}
  </div>
  <div class="ai-bgb-hint">L’area centrale resta libera per foto e testi</div>`;

const renderStylePanel = () => `
  ${panelHead(
    'Definisci lo stile',
    'I colori valgono sempre; tecnica e intensità dei colori contano sulle immagini, mentre l’atmosfera si applica anche ai materiali.'
  )}
  <div class="ai-bgb-sub" data-sub="artistic">
    <div class="ai-bgb-lbl">Tecnica</div>
    <div class="ai-bgb-cards4">${renderCards(
      BUILDER_TECHNIQUES,
      'data-technique'
    )}${renderCustomCard('data-technique')}</div>
    ${renderCustomInput(
      'ai-bgb-technique-custom',
      'Descrivi la tecnica: es. ‘mosaico bizantino’'
    )}
    <div class="ai-bgb-lbl">Intensità dei colori</div>
    <div class="ai-bgb-cards3">${renderCards(
      BUILDER_INTENSITIES,
      'data-intensity'
    )}${renderCustomCard('data-intensity')}</div>
    ${renderCustomInput(
      'ai-bgb-intensity-custom',
      'Descrivi l’intensità dei colori: es. ‘colori quasi desaturati’'
    )}
  </div>
  <div class="ai-bgb-sub" data-sub="atmosphere">
    <div class="ai-bgb-lbl">Atmosfera / luce</div>
    <div class="ai-bgb-cards3">${renderCards(
      ATMOSPHERES,
      'data-atmosphere'
    )}${renderCustomCard('data-atmosphere')}</div>
    ${renderCustomInput(
      'ai-bgb-atmosphere-custom',
      'Descrivi l’atmosfera: es. ‘nebbia leggera al mattino’'
    )}
  </div>
  <div class="ai-bgb-hint" data-sub="artistic-note" style="display:none">Lo sfondo è astratto: tecnica e luce non si applicano. Scegli i colori qui sotto.</div>
  <div class="ai-bgb-hint" data-sub="material-style-note" style="display:none">Il materiale usa la propria intensità; qui puoi regolarne l’atmosfera e la luce.</div>
  <div class="ai-bgb-lbl">Palette</div>
  <div class="ai-bgb-atmo-row">${renderPalettes()}</div>
  ${renderCustomInput(
    'ai-bgb-palette-custom',
    'Descrivi la palette: es. ‘verde bosco e crema’'
  )}
  <label class="ai-bgb-adv">
    <input type="checkbox" class="ai-bgb-text-readability" />
    <span>Priorità alla leggibilità dei testi</span>
  </label>
  <div class="ai-bgb-adv-hint">Mantiene il centro più chiaro e attenua colore, texture, cornice ed elementi. Disattivala per una resa più intensa e illustrativa.</div>`;

const renderElementsPanel = () => `
  ${panelHead(
    'Aggiungi elementi',
    'Tocca le zone del manifesto per collocare simboli e decori. Il centro resta libero per foto e testi.'
  )}
  <div class="ai-bgb-tool-flex">
    <div class="ai-bgb-tool-wrap" data-tool="cells"></div>
    <div class="ai-bgb-elements-side">
      <div class="ai-bgb-elements-home">
        <div class="ai-bgb-lbl">Tocca una zona del manifesto qui a fianco</div>
        <div class="ai-bgb-hint">Aggiungi fino a ${MAX_ELEMENTS} elementi; clicca celle vicine per allargare la zona (fino a 3 celle): una zona composta vale un solo elemento.</div>
        <div class="ai-bgb-lbl">Elementi aggiunti</div>
        <div class="ai-bgb-element-list"></div>
      </div>
      <div class="ai-bgb-picker" style="display:none">
        <div class="ai-bgb-lbl ai-bgb-picker-title"></div>
        ${BUILDER_ELEMENT_CATEGORIES.map(
          (cat) => `
        <div class="ai-bgb-sublbl">${cat.label}</div>
        <div class="ai-bgb-cards3">${renderCards(
          cat.items,
          'data-item',
          (item) => elementIconSvg(item.key)
        )}</div>`
        ).join('')}
        <div class="ai-bgb-sublbl">Personalizzato</div>
        <div class="ai-bgb-custom-row">
          <input type="text" class="form-control ai-bgb-custom-text" maxlength="${CUSTOM_TEXT_MAX_LENGTH}" placeholder="Descrivi l’elemento: es. ‘un faro sul mare’" />
          <button type="button" class="btn btn-light ai-bgb-custom-add">Aggiungi</button>
        </div>
        <div class="ai-bgb-picker-levers"></div>
        <div class="ai-bgb-picker-foot">
          <button type="button" class="btn btn-light ai-bgb-picker-cancel">Annulla</button>
          <button type="button" class="btn btn-light ai-bgb-picker-remove" style="display:none">Rimuovi elemento</button>
        </div>
      </div>
    </div>
  </div>`;

const MARGIN_SIDE_LABELS = {
  top: 'Alto',
  bottom: 'Basso',
  left: 'Sinistra',
  right: 'Destra',
};

// Le chip per-lato portano sia il lato sia il livello: renderChips (una sola
// chiave per voce) non basta, quindi qui si scrive il markup a mano.
const renderMarginSideChips = (side) =>
  FRAME_MARGIN_LEVELS.map(
    (lv) =>
      `<button type="button" class="ai-bgb-chip" data-margin-side="${side}" data-margin-level="${lv.key}">${lv.label}</button>`
  ).join('');

const renderFramePanel = () => `
  ${panelHead(
    'Rifinisci la cornice',
    'Facoltativa: scegli lo stile e come si posa sul manifesto. Puoi anche lasciarla senza.'
  )}
  <div class="ai-bgb-lbl">Stile della cornice</div>
  <div class="ai-bgb-frame-row">${FRAME_STYLES.map(
    (f) =>
      `<div class="ai-bgb-frame" data-frame-style="${
        f.key
      }"><div class="ai-bgb-frame-box ${f.css}">${renderCardAsset(
        f
      )}</div><div class="ai-bgb-frame-t">${f.label}</div></div>`
  ).join('')}</div>
  <input type="text" class="ai-bgb-frame-custom" maxlength="${CUSTOM_TEXT_MAX_LENGTH}" placeholder="Descrivi la cornice che vuoi…" style="display:none" />
  <div class="ai-bgb-lbl">Ricchezza</div>
  <div class="ai-bgb-chips">${renderChips(
    FRAME_RICHNESS,
    'data-frame-richness'
  )}</div>
  <div class="ai-bgb-sub" data-sub="coverage">
    <div class="ai-bgb-lbl">Perimetro</div>
    <div class="ai-bgb-chips">${renderChips(
      FRAME_COVERAGES,
      'data-frame-coverage'
    )}</div>
    <input type="text" class="ai-bgb-coverage-custom" maxlength="${CUSTOM_TEXT_MAX_LENGTH}" placeholder="Descrivi il perimetro che vuoi…" style="display:none" />
  </div>
  <div class="ai-bgb-sub" data-sub="frame-tool" style="display:none">
    <div class="ai-bgb-lbl">Cornice e contenuto</div>
    <div class="ai-bgb-tool-flex">
      <div class="ai-bgb-tool-wrap" data-tool="frame"></div>
    </div>
    <div class="ai-bgb-frame-relation" data-sub="frame-relation">
      <div class="ai-bgb-chips">${renderChips(
        FRAME_RELATIONS,
        'data-frame-relation'
      )}</div>
      <div class="ai-bgb-hint">«Sopra al contenuto»: il fondo prosegue sotto i tratti coperti dalla cornice. «Contenuto dentro»: sui tratti coperti il fondo si ferma al bordo interno; sui tratti aperti prosegue normalmente. Il margine esterno si regola separatamente.</div>
    </div>
  </div>
  <div class="ai-bgb-lbl">Margine esterno del disegno</div>
  <div class="ai-bgb-hint">Regola lo spazio tra il bordo fisico del manifesto e l’intero disegno, eventuale cornice inclusa.</div>
  <div class="ai-bgb-chips ai-bgb-margin-all">${renderChips(
    FRAME_MARGIN_LEVELS,
    'data-frame-margin-all'
  )}</div>
  <label class="ai-bgb-adv" data-sub="margin-adv"><input type="checkbox" class="ai-bgb-margin-toggle" /><span>Margini diversi per lato</span></label>
  <div class="ai-bgb-margin-sides" data-sub="margin-sides" style="display:none">
    ${['top', 'bottom', 'left', 'right']
      .map(
        (side) =>
          `<div class="ai-bgb-margin-row"><span class="ai-bgb-lbl-sm">${
            MARGIN_SIDE_LABELS[side]
          }</span><div class="ai-bgb-chips">${renderMarginSideChips(
            side
          )}</div></div>`
      )
      .join('')}
  </div>`;

export function buildBuilderModalHtml({
  isSuperUser = false,
  orientation = 'vertical',
  ratio,
} = {}) {
  const tabs = TABS.map(
    (key, index) =>
      `<button type="button" class="ai-bgb-tab" data-tab="${key}"><span class="ai-bgb-tab-n">${
        index + 1
      }</span>${TAB_TITLES[key]}</button>`
  ).join('');
  // Il rapporto del manifesto guida anche le card delle essenze: su un
  // progetto orizzontale devono sdraiarsi come il foglio, non restare ritratti.
  const sheetRatio =
    ratio ||
    PREVIEW_FALLBACK_RATIOS[orientation] ||
    PREVIEW_FALLBACK_RATIOS.vertical;
  return `
  <div class="modal fade" id="${MODAL_ID}" tabindex="-1" role="dialog" aria-labelledby="${MODAL_ID}Label" aria-hidden="true" style="--ai-bgb-ratio:${sheetRatio}">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="${MODAL_ID}Label">Crea sfondo con IA</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="ai-bgb-tabs">${tabs}</div>
        <div class="modal-body ai-bgb-body">
          <div class="ai-bgb-cols">
            <div class="ai-bgb-main">
              <div class="ai-bgb-panel" data-panel="base">${renderBasePanel(
                orientation
              )}</div>
              <div class="ai-bgb-panel" data-panel="elements" style="display:none">${renderElementsPanel()}</div>
              <div class="ai-bgb-panel" data-panel="style" style="display:none">${renderStylePanel()}</div>
              <div class="ai-bgb-panel" data-panel="frame" style="display:none">${renderFramePanel()}</div>
              <div class="ai-bgb-extras">
                <details class="ai-bgb-exp">
                  <summary>Dettagli aggiuntivi</summary>
                  <textarea class="form-control ai-bgb-details" rows="2" placeholder="es. ‘con una luce calda dal lato sinistro’"></textarea>
                </details>
                ${
                  isSuperUser
                    ? `<details class="ai-bgb-exp">
                  <summary>Prompt completo</summary>
                  <textarea class="form-control ai-bgb-prompt" rows="4"></textarea>
                  <div class="ai-bgb-hint">Solo super user: se lo modifichi, verrà inviato il testo qui presente</div>
                </details>
                <details class="ai-bgb-exp">
                  <summary>Esporta brief del set</summary>
                  <textarea class="form-control ai-bgb-setbrief" rows="4"></textarea>
                  <div class="ai-bgb-hint">
                    L’essenza del manifesto per il workflow «Set Sfondi». Tagli, formati
                    e varianti li decide n8n, non questo builder.
                    Il set include tre varianti sacre e una laica, tutte nell’angolo inferiore sinistro.
                    Puoi modificare il JSON: dopo il primo intervento manuale le selezioni
                    del builder non lo sovrascrivono.
                    <button type="button" class="btn btn-light btn-sm ai-bgb-setbrief-reset">Ripristina dal builder</button>
                    <button type="button" class="btn btn-light btn-sm ai-bgb-setbrief-copy">Copia</button>
                  </div>
                </details>`
                    : ''
                }
              </div>
            </div>
            ${isSuperUser ? renderPreviewColumn({ orientation, ratio }) : ''}
          </div>
        </div>
        <div class="modal-footer ai-bgb-foot">
          <span class="ai-bgb-credits">Utilizza 2 crediti AI</span>
          <button type="button" class="btn btn-light" data-dismiss="modal">Annulla</button>
          <button type="button" class="btn btn-light ai-bgb-back">← Indietro</button>
          <button type="button" class="btn ai-bgb-next">Avanti →</button>
          <button type="button" class="btn ai-bgb-generate">Genera sfondo</button>
        </div>
      </div>
    </div>
  </div>`;
}
